import { useEffect, useRef, useState } from "react";
import mySvg from "../image/meesok.png";
import { motion } from "framer-motion";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from "@mui/icons-material/Language";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  toast.info("กำลังออกจากระบบ แล้วพบกันใหม่!", {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
  window.location.href = "/";
};

function TopNav({ handleSubmit, handleClickOpen, username, balance }) {
  const { i18n } = useTranslation();
  const navRef = useRef(null);
  const [navHeight, setNavHeight] = useState(0);

  // The bar is position:fixed (out of normal flow), so a spacer of the same
  // height keeps page content from sliding underneath it — the height varies
  // (stacked on mobile, 50px on desktop), hence measured instead of hardcoded.
  useEffect(() => {
    if (!navRef.current) return;
    const observer = new ResizeObserver(() =>
      setNavHeight(navRef.current.offsetHeight),
    );
    observer.observe(navRef.current);
    return () => observer.disconnect();
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  return (
    <>
      <motion.div
        ref={navRef}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        className="animated-div fixed top-0 left-0 w-full z-50"
      >
        <div className="relative overflow-hidden flex flex-col md:flex-row md:justify-between w-[100%] h-auto md:h-[50px] bg-gradient-to-r from-brand-blue-900 via-brand-blue-800 to-brand-blue-900 border-b border-brand-gold-300/50 shadow-card py-2 md:py-0">
          <span
            aria-hidden="true"
            className="pointer-events-none absolute top-[-40%] bottom-[-40%] left-[-28%] w-[22%] bg-gradient-to-r from-transparent via-white/40 to-transparent -skew-x-[18deg] animate-header-sheen"
          />
          <img
            className="h-16 md:h-[80%] w-auto self-center mx-auto md:ml-5"
            src={mySvg}
            alt=""
          />
          <div className="flex items-center justify-center md:justify-end flex-wrap md:flex-nowrap gap-2 md:gap-0 md:space-x-3 flex-row w-full md:w-auto p-2 md:p-3">
            <div className="w-auto h-auto rounded-full ring-1 ring-brand-gold-300/50 bg-white/10 p-1">
              <PersonIcon className="text-brand-gold-200" fontSize="small" />
            </div>
            <span className="font-heading font-bold text-white/90">
              {username && username}
            </span>
            <div className="flex items-center bg-white/10 rounded-pill pl-2 pr-1 p-0.5 gap-0.5">
              <LanguageIcon className="text-white/80" fontSize="small" />
              <select
                value={i18n.language}
                onChange={(e) => changeLanguage(e.target.value)}
                className="bg-transparent text-white/80 text-[10px] xl:text-[12px] font-bold rounded-pill px-1 py-1 focus:outline-none focus:text-white"
              >
                <option className="text-slate-800" value="th">
                  ไทย
                </option>
                <option className="text-slate-800" value="en">
                  EN
                </option>
                <option className="text-slate-800" value="lo">
                  ລາວ
                </option>
                <option className="text-slate-800" value="zh">
                  中文
                </option>
                <option className="text-slate-800" value="vi">
                  VI
                </option>
              </select>
            </div>
            <div
              onClick={handleLogout}
              className="flex flex-row items-center w-auto rounded-pill bg-red-700 h-auto px-3 py-1 hover:bg-red-800 transition-colors cursor-pointer"
            >
              <span className="text-white text-xs">
                <LogoutIcon className="text-white text-xs" fontSize="small" />
              </span>
            </div>
          </div>
        </div>
      </motion.div>
      <div aria-hidden="true" style={{ height: navHeight }} />
    </>
  );
}

export default TopNav;
